import React, {Fragment, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {obtenerAntecedentesCaso, obtenerDatosLlaves} from '../../store/actions/caso-general-action'
import { Auth , LoadingComponent} from 'recupero-comunes'
import Carpeta from './carpeta'
import { clearComboDocument, configuracionFormAction30, obtenerComboDocumentos, obtenerDataCarpeta, obtenerDatosImplicadoTerecero, obtenerUrlCarpeta } from '../../store/actions/carpeta-digital-ation'
import TabsComponent from './tabComponent'

const CarpetaDigitalModal = ({handleClose, idCaso, idImplicado, idOrganizacionCaso, prototipo, docRef, folder}) => {

    const [loading, setLoading]=useState(false)
    const [op, setOp]=useState('cd-upload')    
    const [sendUrl, setSendUrl]=useState('')
    const [query, setQuery] = useState('');
    const [docRef1, setDocRef] = useState(docRef);
    const [prototipo1, setPrototipo] = useState(prototipo);
  
    const [myUrlBase, setUrlBase] = useState('')
    const [region, setRegion] = useState('')
    const [origen, setOrigen] = useState('')

    const dispatch = useDispatch()
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const data_carpeta = useSelector((state) => state.carpetaDigitalReducer)
    const { limpiar, respuestaUrl} = data_carpeta
    const { llaves} = data_recepciona
    const { rutUsuario} = Auth.currentUser()
   
    useEffect(()=>{
      if(respuestaUrl) {       
        setUrlBase(JSON.parse(atob(respuestaUrl.respuestaUrl)).url_cd)
        setRegion(JSON.parse(atob(respuestaUrl.respuestaUrl)).aws_region)
        setOrigen(JSON.parse(atob(respuestaUrl.respuestaUrl)).origenusr)       
      }
    },[respuestaUrl])
    useEffect(()=>{
      if(prototipo===4){
        dispatch(clearComboDocument('implicado1'))        
      }else{
       dispatch(clearComboDocument('asegurado'))
      }     
    },[])
   
   
    useEffect(() => {  
         dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso, "idUsuario":rutUsuario}));
    }, [dispatch])
 

    
    useEffect(() => {
       
        if (llaves) {
          setLoading(true)
            let query = Buffer.from(JSON.stringify({
                idOrgCaso:llaves && llaves["idOrgCaso"],
                idCaso: llaves && llaves["idCaso"]
            })).toString('base64')
            dispatch(obtenerDatosImplicadoTerecero(query))
            .then(()=>{
              let query = Buffer.from(JSON.stringify({"origen":"1"})).toString('base64')
              dispatch(obtenerDataCarpeta(query))
            })
           .then(()=>{
           
            let query = Buffer.from(JSON.stringify({
              rutcia: llaves && llaves['idOrgCaso'],
              idform: 30
          })).toString('base64')
          dispatch(configuracionFormAction30(query))
           }) 
          .then(()=>{
            let query = Buffer.from(JSON.stringify({
              rutCompania:llaves && llaves["idOrgCaso"],
              rutUsuario:rutUsuario,
              idCaso: llaves && llaves["idCaso"],
              idDocumento: 0 
          })).toString('base64')
          dispatch(obtenerComboDocumentos(query))
          })
          .then(()=>{
            let query = Buffer.from(
              JSON.stringify({
                idOrgCaso: llaves['idOrgCaso'],
                idCaso: llaves['idCaso']
              })
            ).toString('base64')
            dispatch(obtenerAntecedentesCaso(query))
          })
          
          .then(()=>{
            
            setLoading(false)
          })
          }
    }, [dispatch, llaves])
    
  
    useEffect(()=>{
      
        if(limpiar){
         
          let docs=limpiar==='asegurado'?0:limpiar==='implicado1'?1:limpiar==='implicado2'?2:limpiar==='implicado3'?3:4
          if(op==='cd-upload' && prototipo===3){
            let localQuery = new Buffer(`op=${'cd-upload'}&dockey=${llaves && llaves["idCaso"]}&docsubkey=${docs}&doctype=${docRef && docRef.uso}&owner=${llaves && llaves['idOrgCaso']}&user=${llaves && llaves['idUsuario']}&filename=${docRef && docRef.uso}_${llaves && llaves['idUsuario']}&filetypes=${docRef && docRef.formato}&region=${region}&origenusr=${origen}`)
          dispatch(obtenerUrlCarpeta(localQuery.toString('base64'))) 
         
        }
        }
      },[limpiar])
     
   
    return (
        <>
          <LoadingComponent show={loading}/> 
          {myUrlBase && 
          <>
          <Carpeta prototipo={prototipo1} setSendUrl={setSendUrl}
             setOp={setOp} op={op} handleClose={handleClose}
             myUrlBase={myUrlBase}
             origen={origen}
             region={region}
             />
          <TabsComponent prototipo={prototipo1} sendUrl={sendUrl} 
           setSendUrl={setSendUrl} op={op} docRef={docRef1}
           myUrlBase={myUrlBase && myUrlBase}
           origen={origen}
           region={region}
           folder={folder}
           /> </> }        
        </>
    )
}

export default CarpetaDigitalModal
